import React from 'react';
// Tiger21 Customizations
import TigerLikeButton from './TigerLikeButton';
import TigerNestedCommentField from './TigerNestedCommentField';
// Material UI
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ReplyIcon from '@mui/icons-material/Reply';

export type TigerCommentItemActionsProps = {
  comment?: any;
  parentComment?: any;
  showSameLevelReply?: any;
};

const TigerCommentItemActions: React.FunctionComponent<
  TigerCommentItemActionsProps
> = (props) => {
  const [showNestedReplyBox, setShowNestedReplyBox] = React.useState(false);
  const childInputRef = React.useRef<HTMLTextAreaElement>();

  React.useEffect(() => {
    childInputRef.current && childInputRef.current.focus();
  });

  function toggleNestedReplyBox() {
    setShowNestedReplyBox((prevValue) => !prevValue);
    // NOTE: When state `showNestedReplyBox` changes our component re-renders.
    // After re-render with new value `true` is complete, two things happen,
    // "side effect" code in our `useEffect` hook runs, and `childInputRef.current`
    // is not null anymore, has the actual ref of input, because it was toggled ON.
    // So we do the autofocusing of the input in the function returned by `useEffect`.
  }

  return (
    <>
      <Stack
        direction='row'
        justifyContent='flex-start'
        alignItems='center'
        spacing={2}
      >
        <TigerLikeButton reaction={props.comment} />
        <Button onClick={toggleNestedReplyBox} startIcon={<ReplyIcon />}>
          Reply
        </Button>
      </Stack>
      {showNestedReplyBox && (
        <Box sx={{ ml: props.showSameLevelReply ? 0 : 6 }}>
          <TigerNestedCommentField
            parentComment={props.parentComment}
            placeholder='Write a reply...'
            childInputRef={childInputRef}
          />
        </Box>
      )}
    </>
  );
};

export default TigerCommentItemActions;
